import { render, staticRenderFns } from "./PersonCapacityBox.vue?vue&type=template&id=349b7d6b&scoped=true"
import script from "./PersonCapacityBox.vue?vue&type=script&lang=js"
export * from "./PersonCapacityBox.vue?vue&type=script&lang=js"
import style0 from "./PersonCapacityBox.vue?vue&type=style&index=0&id=349b7d6b&prod&scoped=true&lang=scss"
import style1 from "./PersonCapacityBox.vue?vue&type=style&index=1&id=349b7d6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349b7d6b",
  null
  
)

export default component.exports